
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minimize-picture-size",
      function () {
        return require("private-next-pages/minimize-picture-size/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minimize-picture-size"])
      });
    }
  